import { MetaInfoState } from "@/interfaces/meta.interface";
import { atom, RecoilState, selectorFamily } from "recoil";

export const metaState: RecoilState<MetaInfoState> = atom({
  key: "metaState",
  default: {},
});

export const collectorMetaState: RecoilState<MetaInfoState> = atom({
  key: "collectorMetaState",
  default: {},
});

export const metaMergeField = selectorFamily<any, keyof MetaInfoState>({
  key: "metaMergeField",
  get: (field) => ({ get }) => get(metaState)[field],
  set: (field) => ({ set }, newValue: MetaInfoState[typeof field]) =>
    set(metaState, (prevState) => ({
      ...prevState,
      [field]: { ...prevState[field], ...newValue },
    })),
});

export const collectorMetaMergeField = selectorFamily<any, keyof MetaInfoState>(
  {
    key: "collectorMetaMergeField",
    get: (field) => ({ get }) => get(collectorMetaState)[field],
    set: (field) => ({ set }, newValue: MetaInfoState[typeof field]) =>
      set(collectorMetaState, (prevState) => ({
        ...prevState,
        [field]: { ...prevState[field], ...newValue },
      })),
  }
);
